import { createSelector } from '@ngrx/store';
import { selectMemberModuleState } from '../selectors/selector';

export const getCardListSelector = createSelector(
    selectMemberModuleState,
    (state) => state?.adhocReport?.getCardList
);

export const getDefaultFilterSelector = createSelector(
    selectMemberModuleState,
    (state) => state?.adhocReport?.getDefaultFilter
);

export const getDefaultTemplateSelector = createSelector(
    selectMemberModuleState,
    (state) => state?.adhocReport?.getDefaultTemplate
);

export const getCardConfigurationSelector = createSelector(
    selectMemberModuleState,
    (state) => state?.adhocReport?.getCardConfiguration
);

export const getTemplatesSelector = createSelector(
    selectMemberModuleState,
    (state) => state?.adhocReport?.getTemplates
);

export const getTemplateSelector = createSelector(
    selectMemberModuleState,
    (state) => state?.adhocReport?.getTemplate
);

export const generateAdhocReportSelector = createSelector(
    selectMemberModuleState,
    (state) => state?.adhocReport?.generateAdhocReport
);

export const createReportTemplateSelector = createSelector(
    selectMemberModuleState,
    (state) => state?.adhocReport?.createReportTemplate
);

export const updateReportTemplateSelector = createSelector(
    selectMemberModuleState,
    (state) => state?.adhocReport?.updateReportTemplate
);

export const removeReportTemplateSelector = createSelector(
    selectMemberModuleState,
    (state) => state?.adhocReport?.removeReportTemplate
);

export const removeReportAuditTrailSelector = createSelector(
    selectMemberModuleState,
    (state) => state?.adhocReport?.removeReportAuditTrail
);

export const getAdhocReportSelector = createSelector(
    selectMemberModuleState,
    (state) => state?.adhocReport?.getAdhocReport
);